const FORBIDDEN = 403;

export default {
  FORBIDDEN,
};
